import * as React from "react";
const SvgError = (props) => /* @__PURE__ */ React.createElement("svg", { width: 25, height: 24, viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M19.5 5L5.5 19M19.5 19L5.5 5", stroke: "#7A0014", strokeWidth: 1.5 }));
export default SvgError;
